import { useSelector } from 'react-redux';

import Carrots from 'cart/common/Carrots';
import Errors from 'cart/common/Errors';
import Items from 'cart/common/Items';
import Loading from 'cart/common/Loading';
import NoItems from 'cart/common/NoItems';
import ScreenReaderMessage from 'cart/common/ScreenReaderMessage';

import Summary from './components/Summary';

const Content = () => {
  const cart = useSelector((state) => state.cart.data);

  const lineCount = cart?.items?.length || 0;

  return (
    <>
      <div className="c7-side-cart__content-container">
        <Errors />
        <Carrots location="Side Cart Top" />
        {lineCount > 0 && <Items />}
        {lineCount === 0 && <NoItems />}
        <Loading />
        <Carrots location="Side Cart Bottom" />
      </div>
      {lineCount > 0 && <Summary />}
      <ScreenReaderMessage />
    </>
  );
};

export default Content;
